











import { Component, Vue } from 'vue-property-decorator'
import Nav from '@/components/navbar/index.vue'
import HealthWork from '@/components/echarts/HealthWork.vue'

@Component({
  name: 'Home',
  components: {
    Nav,
    HealthWork
  }
})
export default class extends Vue {

}
